import Button from 'epn-ui/umd/dist/components/Button';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import auth from '@config/auth.json';
import { isGlobalDomain } from '@config/globalDomain';
import useI18n from '@i18n';
import { generateRoute } from '@utils/router';

import LanguageSwitch from './LanguageSwitch';

const AuthActions: React.FC = () => {
    const { t, locale } = useI18n('Base');

    const redirect = () => {
        window.location.href =
            process.env.NODE_ENV === 'development'
                ? '/ru/auth'
                : generateRoute(auth.AUTH_URL, { locale });
    };

    return (
        <div className="flex items-stretch h-full">
            {!isGlobalDomain && <LanguageSwitch />}
            <Button
                type="primary"
                size="large"
                className="self-center hidden ml-6 !bg-[#FF0000] hover:!bg-[#e50d0d] min-w-[109px] hover:!cursor-pointer md:block"
                onClick={redirect}
            >
                {t('Log in')}
            </Button>
            <FontAwesomeIcon
                className="self-center mr-5 md:hidden text-h2"
                icon={faUser}
                onClick={redirect}
            />
        </div>
    );
};

export default AuthActions;
